module.exports = __webpack_public_path__ + "images/referenzen/werbespot/nkl_tvc_small.jpg";